import React from 'react';

import { Alert, Chip } from '../../../components/ui';
import { BVEvidenceChip } from '../types';

interface EvidenceChipsProps {
  chips: BVEvidenceChip[] | null | undefined;
  onApply: (chip: BVEvidenceChip) => void;
  isBusy?: boolean;
}

export function EvidenceChips({ chips, onApply, isBusy = false }: EvidenceChipsProps) {
  if (!chips || chips.length === 0) {
    return null;
  }

  return (
    <Alert variant="warning" title="Review coverage suggestions">
      <div className="space-y-3">
        <p>
          The current draft is based on a thin review set. Apply one of the suggested scope changes to
          regenerate with more source reviews.
        </p>
        <div className="flex flex-wrap gap-2">
          {chips.map(chip => (
            <Chip
              key={`${chip.action}-${chip.label}`}
              variant="pill"
              onClick={() => onApply(chip)}
              disabled={isBusy}
              title={chip.reason}
            >
              {chip.label}
            </Chip>
          ))}
        </div>
      </div>
    </Alert>
  );
}

export default EvidenceChips;
